
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { isEmpty } from 'lodash';

import { sharedState } from '../../framework/state';
import { ValidationProvider } from 'vee-validate';
import { getFieldNameFromVModelProperty } from '../../framework/util/component_util';
import { getEnumerationOptions, OptionValue } from '../../framework/service/options';
import { Country } from '../../../common/application/model/enums/Country';

@Component({
    components: { ValidationProvider },
})
export default class CountrySelectField extends Vue {
    @Prop(String) name!: string;
    @Prop(String) readonly value!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly disabled!: string;
    @Prop(String) readonly field!: string;

    shared = sharedState;
    local = {
        total: 0,
        loading: false,
        typed: '',
        selectedId: undefined as string | undefined,
        countries: [] as OptionValue[],
    };

    async mounted() {
        this.local.countries = getEnumerationOptions('Country', Object.keys(Country), this);
        await this.modelValueChange(this.value);
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }

    get filteredCountries() {
        return this.local.countries.filter((option) => {
            return option.label.toString().toLowerCase().indexOf(this.local.typed.toLowerCase()) >= 0;
        });
    }

    @Watch('value')
    async modelValueChange(newValue: string) {
        this.local.selectedId = newValue;
        if (this.local.selectedId) {
            this.setTypedAccordingToSelectedId();
        } else {
            this.local.typed = '';
        }
    }

    @Watch('local.selectedId')
    async selectedIdChange(newValue: string) {
        if (this.local.typed === '-') {
            this.local.typed = '';
        }
        if (!isEmpty(newValue)) {
            this.$emit('input', newValue);
        } else {
            this.$emit('input', undefined);
        }
    }

    private setTypedAccordingToSelectedId() {
        if (typeof this.local.selectedId === 'undefined') {
            this.local.typed = '';
            return;
        }

        const selectedCountry = this.local.countries.find((country) => this.local.selectedId === country.id);
        this.local.typed = selectedCountry ? selectedCountry.label : '';
    }
}
